// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loadscreen {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--ion-background-color);
}
.loadscreen.--fullscreen {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}
.loadscreen__content {
  text-align: center;
}
.loadscreen__content .spinner {
  width: 20vw;
  height: 20vw;
  max-width: 100px;
  max-height: 100px;
}`, "",{"version":3,"sources":["webpack://./src/app/general-components/loadscreen/loadscreen.component.scss"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,6CAAA;AAAJ;AAEI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAAR;AAGI;EACI,kBAAA;AADR;AAGQ;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AADZ","sourcesContent":["\n.loadscreen {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: var(--ion-background-color);\n\n    &.--fullscreen {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        width: 100%;\n        height: 100%;\n        z-index: 9999;\n    }\n\n    &__content {\n        text-align: center;\n        \n        .spinner {\n            width: 20vw;\n            height: 20vw;\n            max-width: 100px;\n            max-height: 100px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
